"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDataTable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _size = _interopRequireDefault(require("lodash/size"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _ = require("./..");

var _value = require("../../skybase-core/utils/value");

var _sbDataTableThead = require("./sb-data-table-thead");

var _sbDataTableTbody = require("./sb-data-table-tbody");

var _sbDataTableTgroup = require("./sb-data-table-tgroup");

var _sbPagination = require("../sb-pagination");

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PAGE_SIZE = 10;
var LEFT = _constants.expandedRowsArrowPositions.LEFT,
    RIGHT = _constants.expandedRowsArrowPositions.RIGHT;
var SINGLE = _constants.expandedRowsTypes.SINGLE,
    MULTIPLE = _constants.expandedRowsTypes.MULTIPLE;

var SbDataTable = /*#__PURE__*/function (_Component) {
  _inherits(SbDataTable, _Component);

  var _super = _createSuper(SbDataTable);

  function SbDataTable(props) {
    var _this;

    _classCallCheck(this, SbDataTable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnSort", function (name) {
      var onSortChange = _this.props.onSortChange;

      _this.setState(function (prevState) {
        var ASC = _constants.enumOrderBy.ASC,
            DESC = _constants.enumOrderBy.DESC;
        var newOrder = DESC;

        if (prevState.sortBy) {
          var _prevState$sortBy = prevState.sortBy,
              sortCol = _prevState$sortBy.sortCol,
              sortOrder = _prevState$sortBy.sortOrder;

          if (sortCol === name) {
            newOrder = sortOrder === ASC ? DESC : ASC;
          }
        }

        var sortBy = {
          sortCol: name,
          sortOrder: newOrder
        };
        onSortChange(sortBy);
        return {
          sortBy: sortBy
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPaginationChange", function (_ref) {
      var pageSize = _ref.pageSize,
          pageNumber = _ref.pageNumber;
      var onChange = _this.props.paginationProps.onChange;

      _this.setState({
        currentPage: pageNumber,
        rowsPerPage: pageSize
      });

      if (onChange) {
        onChange({
          pageSize: pageSize,
          pageNumber: pageNumber
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCollapseGroup", function (groupId) {
      var _window, _window$getSelection, _window$getSelection$, _window$getSelection$2;

      (_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : (_window$getSelection$2 = _window$getSelection$.removeAllRanges) === null || _window$getSelection$2 === void 0 ? void 0 : _window$getSelection$2.call(_window$getSelection$); // eslint-disable-line

      _this.setState(function (prevState) {
        var newState = prevState.collapsed;
        var indexOfGroupId = newState.indexOf(groupId);

        if (indexOfGroupId !== -1) {
          newState.splice(indexOfGroupId, 1);
        } else {
          newState.push(groupId);
        }

        return {
          collapsed: newState
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleExpandRow", function (event, id) {
      var _window2, _window2$getSelection, _window2$getSelection2, _window2$getSelection3;

      (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$getSelection = _window2.getSelection) === null || _window2$getSelection === void 0 ? void 0 : (_window2$getSelection2 = _window2$getSelection.call(_window2)) === null || _window2$getSelection2 === void 0 ? void 0 : (_window2$getSelection3 = _window2$getSelection2.removeAllRanges) === null || _window2$getSelection3 === void 0 ? void 0 : _window2$getSelection3.call(_window2$getSelection2); // eslint-disable-line

      event.stopPropagation();
      var _this$props = _this.props,
          expandableRowsType = _this$props.expandableRowsType,
          onExpandableRowToggle = _this$props.onExpandableRowToggle,
          expandedRowsProp = _this$props.expandedRows;

      if (onExpandableRowToggle) {
        onExpandableRowToggle(id);
      }

      if (!expandedRowsProp) {
        _this.setState(function (prevState) {
          var expandedRows = prevState.expandedRows;

          if (expandedRows.includes(id)) {
            return {
              expandedRows: expandedRows.filter(function (rowId) {
                return rowId !== id;
              })
            };
          }

          if (expandableRowsType === SINGLE) {
            return {
              expandedRows: [id]
            };
          }

          return {
            expandedRows: expandedRows.concat(id)
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderPagination", function (data) {
      var _this$props2 = _this.props,
          _this$props2$paginati = _this$props2.paginationProps,
          className = _this$props2$paginati.className,
          onChange = _this$props2$paginati.onChange,
          pageNumber = _this$props2$paginati.pageNumber,
          pageSize = _this$props2$paginati.pageSize,
          totalCount = _this$props2$paginati.totalCount,
          restPaginationProps = _objectWithoutProperties(_this$props2$paginati, ["className", "onChange", "pageNumber", "pageSize", "totalCount"]),
          asyncData = _this$props2.asyncData;

      var _this$state = _this.state,
          currentPage = _this$state.currentPage,
          rowsPerPage = _this$state.rowsPerPage;
      var onChangeHandler = asyncData ? onChange : _this.onPaginationChange;
      var pageNumberProp = pageNumber || asyncData ? pageNumber : currentPage;
      var pageSizeProp = pageSize || asyncData ? pageSize : rowsPerPage;
      var totalCountProp = totalCount || asyncData ? totalCount : (0, _utils.calculateAllRows)(data);
      return /*#__PURE__*/_react.default.createElement(_sbPagination.SbPagination, _extends({}, restPaginationProps, {
        onChange: onChangeHandler,
        pageNumber: pageNumberProp,
        pageSize: pageSizeProp,
        totalCount: totalCountProp,
        className: (0, _classnames.default)('sb-data-table-pagination', className)
      }));
    });

    var _this$props3 = _this.props,
        enablePagination = _this$props3.enablePagination,
        _this$props3$paginati = _this$props3.paginationProps,
        _pageSize = _this$props3$paginati.pageSize,
        _pageNumber = _this$props3$paginati.pageNumber;
    _this.state = {
      collapsed: props.collapsed,
      sortBy: props.defaultSortBy,
      currentPage: enablePagination ? _pageNumber || 1 : 1,
      rowsPerPage: enablePagination ? _pageSize || DEFAULT_PAGE_SIZE : DEFAULT_PAGE_SIZE,
      expandedRows: props.expandedRows || []
    };
    return _this;
  }

  _createClass(SbDataTable, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          collapsed = _this$state2.collapsed,
          sortBy = _this$state2.sortBy,
          currentPage = _this$state2.currentPage,
          rowsPerPage = _this$state2.rowsPerPage,
          expandedRows = _this$state2.expandedRows;
      var _this$props4 = this.props,
          className = _this$props4.className,
          cellFormatter = _this$props4.cellFormatter,
          columns = _this$props4.columns,
          containerStyle = _this$props4.containerStyle,
          data = _this$props4.data,
          emptyMessage = _this$props4.emptyMessage,
          groupBy = _this$props4.groupBy,
          groupRender = _this$props4.groupRender,
          id = _this$props4.id,
          innerContainerStyle = _this$props4.innerContainerStyle,
          requiredGroups = _this$props4.requiredGroups,
          rowFormatter = _this$props4.rowFormatter,
          rowsUniqueKeyName = _this$props4.rowsUniqueKeyName,
          sortable = _this$props4.sortable,
          stickyHeader = _this$props4.stickyHeader,
          style = _this$props4.style,
          loading = _this$props4.loading,
          enablePagination = _this$props4.enablePagination,
          asyncData = _this$props4.asyncData,
          _this$props4$paginati = _this$props4.paginationProps,
          pageSize = _this$props4$paginati.pageSize,
          pageNumber = _this$props4$paginati.pageNumber,
          expandableRowFormatter = _this$props4.expandableRowFormatter,
          expandableRowsArrowPosition = _this$props4.expandableRowsArrowPosition;
      var formattedData = (0, _utils.formatData)({
        data: data,
        groupByIteratee: groupBy,
        sortByShape: sortBy,
        requiredGroups: requiredGroups
      });
      var pS = !(0, _value.isNullOrUndefined)(pageSize) ? pageSize : rowsPerPage;
      var pN = !(0, _value.isNullOrUndefined)(pageNumber) ? pageNumber : currentPage;
      var wrapperClassNames = (0, _classnames.default)(className, 'sb-data-table-container');
      var tempWrapperStyle = stickyHeader ? _objectSpread(_objectSpread({}, containerStyle), {}, {
        height: stickyHeader
      }) : containerStyle;
      var wrapperStyle = Object.assign({}, style, tempWrapperStyle);
      var minIndex = (pN - 1) * pS;
      var maxIndex = pS ? minIndex + pS : -1;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: wrapperClassNames,
        style: wrapperStyle,
        id: id
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-data-table-inner-container",
        style: innerContainerStyle
      }, /*#__PURE__*/_react.default.createElement("table", {
        className: "sb-data-table"
      }, /*#__PURE__*/_react.default.createElement(_sbDataTableThead.SbDataTableThead, {
        columns: columns,
        sortable: sortable,
        sortBy: sortBy,
        onSort: this.handleOnSort,
        stickyHeader: stickyHeader,
        expandableRowFormatter: expandableRowFormatter,
        expandableRowsArrowPosition: expandableRowsArrowPosition
      }), !loading && emptyMessage && (0, _size.default)(formattedData) === 0 && /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
        className: "sb-table-not-found-message"
      }, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: 100
      }, emptyMessage))), loading && /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
        className: "sb-table-loader-row"
      }, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: 100
      }, /*#__PURE__*/_react.default.createElement(_.SbLoader, {
        show: true,
        size: "xxs"
      })))), !loading && (groupBy ? /*#__PURE__*/_react.default.createElement(_sbDataTableTgroup.SbDataTableTgroup, {
        columns: columns,
        collapsed: collapsed,
        data: formattedData,
        groupBy: groupBy,
        groupRender: groupRender,
        cellFormatter: cellFormatter,
        rowFormatter: rowFormatter,
        rowsUniqueKeyName: rowsUniqueKeyName,
        onCollapse: this.toggleCollapseGroup,
        onExpandRow: this.toggleExpandRow,
        minIndex: enablePagination ? minIndex : -1,
        maxIndex: enablePagination ? maxIndex : -1,
        asyncData: enablePagination && asyncData,
        expandableRowFormatter: expandableRowFormatter,
        expandedRows: expandedRows,
        expandableRowsArrowPosition: expandableRowsArrowPosition
      }) : /*#__PURE__*/_react.default.createElement(_sbDataTableTbody.SbDataTableTbody, {
        columns: columns,
        data: formattedData,
        cellFormatter: cellFormatter,
        rowFormatter: rowFormatter,
        rowsUniqueKeyName: rowsUniqueKeyName,
        onExpandRow: this.toggleExpandRow,
        minIndex: enablePagination ? minIndex : null,
        maxIndex: enablePagination ? maxIndex : null,
        asyncData: enablePagination && asyncData,
        expandableRowFormatter: expandableRowFormatter,
        expandedRows: expandedRows,
        expandableRowsArrowPosition: expandableRowsArrowPosition
      }))))), enablePagination && this.renderPagination(formattedData));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var expandedRows = nextProps.expandedRows;
      var expandedRowsState = prevState.expandedRows;

      if (expandedRows && !(0, _isEqual.default)(expandedRows, expandedRowsState)) {
        return {
          expandedRows: expandedRows
        };
      }

      return null;
    }
  }]);

  return SbDataTable;
}(_react.Component);

exports.SbDataTable = SbDataTable;

_defineProperty(SbDataTable, "propTypes", {
  className: _propTypes.default.string,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    label: _propTypes.default.node
  })).isRequired,
  containerStyle: _propTypes.default.object,
  // eslint-disable-line
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  emptyMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  defaultSortBy: _propTypes.default.shape({
    sortCol: _propTypes.default.string.isRequired,
    sortOrder: _propTypes.default.oneOf([_constants.enumOrderBy.ASC, _constants.enumOrderBy.DESC]).isRequired
  }),
  collapsed: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
  groupBy: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  id: _propTypes.default.string,
  innerContainerStyle: _propTypes.default.object,
  // eslint-disable-line
  requiredGroups: _propTypes.default.arrayOf(_propTypes.default.string),
  rowsUniqueKeyName: _propTypes.default.string,
  sortable: _propTypes.default.bool,
  cellFormatter: _propTypes.default.func,
  groupRender: _propTypes.default.func,
  rowFormatter: _propTypes.default.func,
  expandableRowFormatter: _propTypes.default.func,
  onSortChange: _propTypes.default.func,
  stickyHeader: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line
  loading: _propTypes.default.bool,
  paginationProps: _propTypes.default.object,
  // eslint-disable-line
  enablePagination: _propTypes.default.bool,
  asyncData: _propTypes.default.bool,
  expandableRowsArrowPosition: _propTypes.default.oneOf([LEFT, RIGHT]),
  expandableRowsType: _propTypes.default.oneOf([SINGLE, MULTIPLE]),
  onExpandableRowToggle: _propTypes.default.func,
  expandedRows: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))
});

_defineProperty(SbDataTable, "defaultProps", {
  className: null,
  containerStyle: {},
  collapsed: [],
  emptyMessage: false,
  defaultSortBy: null,
  groupBy: null,
  id: null,
  innerContainerStyle: {},
  requiredGroups: [],
  rowsUniqueKeyName: null,
  sortable: true,
  cellFormatter: function cellFormatter(val) {
    return val;
  },
  groupRender: function groupRender(val) {
    return val;
  },
  rowFormatter: function rowFormatter() {
    return {};
  },
  expandableRowFormatter: null,
  onSortChange: function onSortChange(val) {
    return val;
  },
  stickyHeader: null,
  style: null,
  loading: false,
  paginationProps: {},
  enablePagination: false,
  asyncData: true,
  expandableRowsArrowPosition: RIGHT,
  expandableRowsType: MULTIPLE,
  onExpandableRowToggle: null,
  expandedRows: null
});
//# sourceMappingURL=sb-data-table.js.map